import { ofetch } from 'ofetch';
import { matchRoutes } from 'umi';

export function onRouteChange({ clientRoutes, location }: any) {
  const route = matchRoutes(clientRoutes, location.pathname)?.pop()?.route as any;
  if (route) {
    document.title = route.title || '';
  }
}

/* export function render(oldRender: any) {
  ofetch<any>('/api/auth').then(auth => {
    if (auth.isLogin) { oldRender() }
    else {
      location.href = '/login';
      oldRender()
    }
  });
} */